import React from 'react';

function HomeKey(props: object) {
  return (
    <svg
      width="392"
      height="351"
      viewBox="0 0 392 351"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="175.359"
        cy="175.5"
        r="175.359"
        fill="#006AF9"
        fillOpacity="0.04"
      />
      <path
        opacity="0.8"
        d="M196.053 205.822H84.3555V257.334H196.053V205.822Z"
        fill="#CFDFFF"
      />
      <path
        opacity="0.8"
        d="M61.375 205.821L84.9961 184.9H206.405L197.636 205.821H61.375Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M198.024 129.469H94.8359V195.646H198.024V129.469Z"
        fill="#CFDFFF"
      />
      <path
        opacity="0.8"
        d="M166.262 144.567H125.191V174.528H166.262V144.567Z"
        fill="#B7CCF5"
      />
      <path
        opacity="0.8"
        d="M147.149 144.567H143.797V174.528H147.149V144.567Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M166.262 158.407H125.191V160.84H166.262V158.407Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M166.262 141.869H125.191V144.567H166.262V141.869Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M125.189 141.869H121.465V174.528H125.189V141.869Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M170.229 141.869H166.262V174.528H170.229V141.869Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M170.226 174.528H121.465V177.713H170.226V174.528Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M224.571 110.927L199.676 128.832C199.1 129.246 198.409 129.469 197.7 129.469H96.695C93.3201 129.469 92.0243 125.07 94.861 123.241L167.086 76.6701C167.593 76.3429 168.178 76.1572 168.781 76.1323C169.384 76.1074 169.982 76.2441 170.514 76.5284L215.808 100.719L224.19 105.196C224.696 105.467 225.126 105.863 225.437 106.346C225.749 106.828 225.933 107.383 225.971 107.956C226.009 108.529 225.9 109.103 225.656 109.623C225.411 110.143 225.037 110.591 224.571 110.927Z"
        fill="#A8CBF3"
      />
      <path
        opacity="0.8"
        d="M182.219 210.391H90.7773V257.334H182.219V210.391Z"
        fill="#E9F0FD"
      />
      <path
        opacity="0.8"
        d="M182.219 210.391H90.7773V211.792H182.219V210.391Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 213.622H90.7773V215.023H182.219V213.622Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 217.932H90.7773V219.333H182.219V217.932Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 222.242H90.7773V223.643H182.219V222.242Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 227.629H90.7773V229.029H182.219V227.629Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 233.015H90.7773V234.416H182.219V233.015Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 238.402H90.7773V239.803H182.219V238.402Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 243.789H90.7773V245.189H182.219V243.789Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M182.219 249.175H90.7773V250.576H182.219V249.175Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M198.024 129.469H94.8359V136.938H198.024V129.469Z"
        fill="#BECEF8"
      />
      <path
        opacity="0.8"
        d="M183.224 255.669H89.7617V209.473H183.224V255.669ZM91.7817 253.836H181.204V211.306H91.7817V253.836Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M194.207 133.294L178.102 195.646H194.207V133.294Z"
        fill="#BECEF8"
      />
      <path
        opacity="0.8"
        d="M263.711 133.294H194.211V257.334H263.711V133.294Z"
        fill="#DCE6FF"
      />
      <path
        opacity="0.8"
        d="M265.904 193.581H191.727V199.471H265.904V193.581Z"
        fill="#A8CBF3"
      />
      <path
        opacity="0.8"
        d="M249.375 146.567H208.305V176.528H249.375V146.567Z"
        fill="#B7CCF5"
      />
      <path
        opacity="0.8"
        d="M230.259 146.567H226.906V176.528H230.259V146.567Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.43"
        d="M249.375 160.407H208.305V162.84H249.375V160.407Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M249.375 143.868H208.305V146.567H249.375V143.868Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M208.302 143.868H204.578V176.528H208.302V143.868Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M253.338 143.868H249.371V176.528H253.338V143.868Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M253.34 176.528H204.578V179.713H253.34V176.528Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M268.291 189.424H188.863V195.314H268.291V189.424Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M224.572 110.927L199.676 128.832C199.101 129.246 198.41 129.469 197.701 129.47H179.867C191.982 120.057 203.963 110.474 215.808 100.72L224.19 105.197C224.697 105.468 225.126 105.863 225.438 106.346C225.75 106.829 225.933 107.383 225.971 107.956C226.01 108.53 225.901 109.103 225.656 109.623C225.411 110.143 225.038 110.592 224.572 110.927Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M194.211 133.294L228.579 101.245L263.711 133.294H194.211Z"
        fill="#A8CBF3"
      />
      <path
        opacity="0.8"
        d="M263.711 133.294H194.211V138.841H263.711V133.294Z"
        fill="#BECEF8"
      />
      <path
        opacity="0.8"
        d="M268.291 189.424H188.863V192.369H268.291V189.424Z"
        fill="#90B2E6"
      />
      <path
        opacity="0.8"
        d="M263.707 254.753H84.3555V257.334H263.707V254.753Z"
        fill="#A1BDF4"
      />
      <path
        opacity="0.8"
        d="M257.802 177.188H200.695V179.796H257.802V177.188Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M257.802 188.184H200.695V190.792H257.802V188.184Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M205.559 179.795H202.441V189.317H205.559V179.795Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M213.637 179.795H210.52V189.317H213.637V179.795Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M221.72 179.795H218.602V189.317H221.72V179.795Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M229.801 179.795H226.684V189.317H229.801V179.795Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M237.879 179.795H234.762V189.317H237.879V179.795Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M247.981 179.795H244.863V189.317H247.981V179.795Z"
        fill="#F1F3FF"
      />
      <path
        opacity="0.8"
        d="M256.059 179.795H252.941V189.317H256.059V179.795Z"
        fill="#F1F3FF"
      />
      <rect
        x="210.625"
        y="208.528"
        width="26.4797"
        height="46.3227"
        fill="#C9DBFF"
      />
      <circle cx="214.231" cy="226.583" r="1.20362" fill="#E6EEFE" />
      <rect
        x="213.027"
        y="230.193"
        width="2.40724"
        height="4.81448"
        fill="#E6EEFE"
      />
      <path
        d="M273.2 256.419C283.318 258.075 292.913 251.444 294.618 241.618C296.323 231.792 289.495 222.473 279.378 220.817C270.972 219.442 262.944 223.794 259.484 230.937C246.435 228.865 233.386 226.794 220.337 224.721C219.514 231.013 224.953 237.396 231.139 239.429C230.99 238.229 232.372 236.681 233.602 236.493C234.831 236.305 236.131 237.186 236.371 238.373C236.947 237.166 238.631 236.808 239.957 237.141C241.284 237.475 242.263 238.804 242.162 240.13C247.15 242.053 252.698 242.672 258.059 242.057C259.498 249.228 265.348 255.135 273.2 256.419ZM288.687 240.648C288.166 243.654 285.234 245.681 282.139 245.174C279.027 244.665 276.941 241.818 277.462 238.811C277.983 235.805 280.916 233.778 284.028 234.288C287.123 234.794 289.21 237.641 288.687 240.648Z"
        fill="#93B4E8"
      />
      <path
        d="M311.027 226.971C304.87 224.299 300.727 218.273 294.716 215.289C290.033 212.964 284.369 212.707 279.494 214.597C275.423 216.176 271.836 219.372 270.521 223.535C268.78 229.048 271.419 235.328 275.962 238.904C280.505 242.48 286.57 243.659 292.342 243.315C298.113 242.971 303.7 241.239 309.219 239.515C311.331 235.591 308.939 230.907 311.027 226.971Z"
        fill="#E3EBFF"
      />
      <path
        d="M391.998 219.013C391.998 219.013 368.965 223.209 309.886 217.215C309.886 217.215 302.004 235.992 304.786 249.901C304.786 249.901 367.805 259.455 391.998 255.057V219.013Z"
        fill="#AAC7F4"
      />
    </svg>
  );
}

export default HomeKey;
